document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.multicolumns_read_more_less').forEach((card) => {
    const btn = card.querySelector('.readmore-toggle');
    const textBox = card.querySelector('.readmore-content');

    if (!btn || !textBox) return;

    btn.addEventListener('click', () => {
      card.classList.toggle('expanded');
      btn.textContent = card.classList.contains('expanded') ? "Read less" : "Read more";
    });
  });
});
